import { MessageCircle } from "lucide-react";
import { whatsappLink } from "../config/site";

export const FloatingWhatsApp = () => (
  <a
    data-testid="floating-whatsapp-btn"
    href={whatsappLink()}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Falar no WhatsApp"
    className="lg:hidden fixed bottom-6 right-5 z-50 flex items-center gap-2.5 min-h-[56px] pl-4 pr-5 rounded-full bg-[#D9A94A] text-[#0A0A0C] shadow-[0_8px_30px_-6px_rgba(217,169,74,0.55)] active:scale-95 transition-transform duration-200"
  >
    <span className="absolute inset-0 rounded-full border border-[#D9A94A] whatsapp-pulse pointer-events-none" />
    <MessageCircle size={22} strokeWidth={2} />
    <span className="text-[11px] font-bold tracking-[0.12em] uppercase">WhatsApp</span>
  </a>
);
